import { Box, Flex } from '@vimeo/bokeh';

import { withResponsiveValue } from '../hocs/withResponsiveValue';
import { BANNER_GRADIENTS } from '../utils/style';
import { BannerAlignment, ResponsiveValue } from '../utils/types';

type FeaturedThumbnailProps = {
  alignment: BannerAlignment;
  isMobilePreview?: boolean;
  isShowcaseEmpty?: boolean;
  thumbnail?: string;
  bannerHeight?: string;
};

const FeaturedThumbnailComponent = ({
  alignment = 'left',
  thumbnail,
  isShowcaseEmpty,
  getResponsiveValue,
  bannerHeight = '50vh',
}: FeaturedThumbnailProps & ResponsiveValue) => {
  const height = getResponsiveValue(
    isShowcaseEmpty && !thumbnail ? { base: '220px', sm: '294px' } : { base: '320px', sm: '480px' },
  );
  const gradient = getResponsiveValue({
    base: 'linear-gradient(0deg,black,transparent),linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent 160px)',
    md: BANNER_GRADIENTS[alignment],
  });

  if (thumbnail)
    return (
      <Flex
        position="absolute"
        left={0}
        width="100%"
        minHeight={height}
        height={isShowcaseEmpty && !thumbnail ? height : bannerHeight}
        backgroundImage={`url(${thumbnail})`}
        backgroundSize="cover"
        backgroundPosition="center"
      >
        <Box
          position="absolute"
          bottom="0"
          left="0"
          right="0"
          height="100%" /* Bottom half gradient */
          background={gradient}
        />
      </Flex>
    );
  // If no thumbnail is selected, return a solid color as background image
  return (
    <Flex
      position="absolute"
      left={0}
      width="100%"
      minHeight={height}
      height={isShowcaseEmpty && !thumbnail ? height : bannerHeight}
      background="fill-surface"
    />
  );
};

export const FeaturedThumbnail = withResponsiveValue<FeaturedThumbnailProps>(
  FeaturedThumbnailComponent,
);
